import { render, staticRenderFns } from "./credit-notes-add-modal.vue?vue&type=template&id=5652d840&"
import script from "./credit-notes-add-modal.vue?vue&type=script&lang=js&"
export * from "./credit-notes-add-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports